<template>
  <div
    ref="itemRef"
    :class="[
      isSingleTag ? 'dict-item__single' : 'dict-item',
      {
        active: checkActive(props.data) || !!checkTags?.length,
      },
    ]"
  >
    <template v-if="data?.children?.length">
      <a-dropdown
        v-model:open="visible"
        placement="bottomLeft"
        trigger="click"
        destroyPopupOnHide
        :overlayStyle="{
          whiteSpace: 'nowrap',
          zIndex: 99,
          backgroundColor: 'var(--back-0)',
        }"
      >
        <div class="h-full flex-y-center">
          <a
            class="flex-y-center gap-x-[4px] cursor-pointer leading-[24px] font-normal text-font-60 hover:text-font-1"
            :href="`/template?tag_ids=${data.children.map(item => item.ids).join('_')}`"
            @click="handClick"
          >
            {{ data.tag_name }}
            <TagIcon :data="data" />
          </a>
          <template v-if="checkTags?.length">
            <CloseCircleFilled class="close-icon" @click="handleClose" />
            <span>：</span>
            <div class="flex gap-x-[2px]">
              <span
                v-for="x in checkTags"
                :key="x.tag_id"
                class="check-tag cursor-pointer flex-y-center"
                @click="onChildChange(false, x)"
              >
                {{ x.tag_name }}
                <CloseOutlined class="text-font-1 text-[9px] ml-[6px] opacity-60" />
              </span>
            </div>
          </template>
          <a-divider type="vertical" style="height: 12px; color: var(--text-1-20)" />
          <iconpark-icon class="down-icon" name="down" size="10" />
        </div>
        <template #overlay>
          <a-menu>
            <a-menu-item v-for="x in data.children" :key="x.tag_id" class="item-menu">
              <a-checkbox
                class="check"
                :checked="checkActive(x)"
                :value="x.tag_id"
                @change="onChildChange($event.target.checked, x)"
              >
                {{ x.tag_name }}
              </a-checkbox>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </template>
    <span v-else class="cursor-pointer item-link" @click="handClick">
      {{ data.tag_name }}
      <TagIcon :data="data" size="small" />
    </span>
  </div>
</template>

<script lang="ts" setup>
import TagIcon from './tag-icon.vue';
import type { Tag } from '~/api/interface';

const props = defineProps<{ data: Tag; checks: Tag[] }>();
const emit = defineEmits(['change']);
const visible = ref(false);
const itemRef = ref<HTMLElement>();

const checkActive = (data: Tag) => {
  return props?.checks?.findIndex(x => x.ids === data.ids) !== -1;
  // return props.checks.find((item) => item.tag_id === data.tag_id)
};

const isSingleTag = computed(() => props.data?.children?.length === 0);

const checkTags = computed(() => {
  if (!props.data?.children?.length) {
    return [];
  }

  return props?.data?.children?.filter((x: Tag) => checkActive(x)) || [];
});

const handleClose = () => {
  visible.value = false;
  checkTags.value.forEach(x => emit('change', x, false));
};

const handClick = (e: Event) => {
  e.preventDefault();

  if (props?.data?.children?.length) {
    if (props?.data?.children?.length === checkTags.value.length) {
      emit('change', props?.data?.children, false);
    } else {
      emit('change', props?.data?.children, true);
    }
  } else {
    emit('change', props.data, !checkActive(props.data));
  }
};

const onChildChange = (checked: boolean, data: Tag) => {
  emit('change', data, checked);
};

// const getPopupContainer = () => {
//   return itemRef.value as HTMLElement
// }
</script>

<style lang="scss" scoped>
.dict-item,
.dict-item__single {
  @apply p-[4px_6px] rounded-[6px] text-font-60 flex-y-center relative hover:text-primary;

  .item-link {
    @apply flex-y-center gap-x-[4px];
    color: var(--text-1-60);
    line-height: 24px;
    &:hover {
      color: var(--text-1);
    }
  }

  &.active {
    @apply font-semibold text-font-1;
    .item-link {
      @apply font-semibold text-font-1;
    }
  }
  .close-icon {
    @apply absolute top-[9px] right-[6px] text-back-6 hidden;
  }
  &:hover {
    .close-icon {
      @apply block;
    }
  }
}

.dict-item.active {
  @apply bg-back-2;
  &:hover {
    .down-icon {
      @apply invisible;
    }
  }
}

.check-tag {
  @apply p-[0_6px] rounded-[4px] leading-[24px] font-medium bg-back-1;
}
.item-menu {
  &:hover .check,
  .ant-checkbox-wrapper-checked {
    @apply text-primary;
  }
}

ul.ant-dropdown-menu {
  max-height: 300px;
  overflow: auto;
}
</style>
